import { jsxs as n, jsx as o } from "react/jsx-runtime";
import { NoCouponsIcon as s } from "../../../assets/svgs/NoCouponIcon.js";
const i = () => /* @__PURE__ */ n("div", { className: "noCoupons", children: [
  /* @__PURE__ */ o("h1", { className: "noCoupons-h3", children: "Não há cupons disponíveis no momento" }),
  /* @__PURE__ */ o(s, {}),
  /* @__PURE__ */ o("p", { className: "noCoupons-p", children: "Caso você tenha algum código de cupom em mãos, insira o código acima, ou entre no seu carrinho de compras e insira o código no campo ‘Cupom de Desconto’." })
] });
export {
  i as NoCoupons
};
